import React from "react";
import Container from "../layout/Container";

const Icon = () => {
  return (
    <>
      <Container>
        <div className="my-7 flex items-center">
          <div className="w-[50%]">
            <h3 className="font-pop text-2xl font-bold text-textColor">
              2017 BMW M3 Competition Auto For Sale R819,900{" "}
            </h3>
          </div>
          <div className="flex w-[50%] items-center justify-end gap-x-5">
            <img
              className="cursor-pointer"
              src="assets/images/auction_listing/facebook.png"
              alt="facebook"
            />
            <img
              className="cursor-pointer"
              src="assets/images/auction_listing/messenger.png"
              alt="messenger"
            />
            <img
              className="cursor-pointer"
              src="assets/images/auction_listing/instagram.png"
              alt="instagram"
            />
            <img
              className="cursor-pointer"
              src="assets/images/auction_listing/whatsapp.png"
              alt="whatsapp"
            />
            <img
              className="cursor-pointer"
              src="assets/images/auction_listing/frame.png"
              alt="frame"
            />
            <img
              className="cursor-pointer"
              src="assets/images/auction_listing/group.png"
              alt="group"
            />
          </div>
        </div>
      </Container>
    </>
  );
};

export default Icon;
